var RegionPage;
(function (RegionPage) {
    var c;
    var communicator = /** @class */ (function () {
        function communicator() {
            this.receiveMessage = function (event) {
                var eventData = event.data;
                if (eventData.type) {
                    switch (eventData.type) {
                        case "widgetstarted": {
                            $("#eventsBasic .placeholder").remove();
                            break;
                        }
                        case "resize": {
                            if (eventData.hasOwnProperty("height")) {
                                $("#eventsBasic").css("height", eventData.height);
                            }
                            break;
                        }
                    }
                }
                ;
            };
            this.addListeners = function () {
                window.addEventListener("message", this.receiveMessage, false);
            };
        }
        return communicator;
    }());
    function loadRegionMembers() {
        $("#lstMembers").not('.slick-initialized').slick({
            slidesToShow: $("#lstMembers").attr("data-slick-slidesToShow"),
            slide: $("#lstMembers").attr("data-slick-slideElement"),
            autoplay: true
        });
    }
    function Init(council) {
        $(function () {
            c = new communicator();
            c.addListeners();
            Common.InitCategoryLinks();
            Common.LoadBackgroundImages();
            Common.SetCurrentCouncil(council);
            loadRegionMembers();
            Common.LoadPromotions();
        });
    }
    RegionPage.Init = Init;
})(RegionPage || (RegionPage = {}));
